'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _PhoneNumberInput = require('ui-addon-i18n/components/PhoneNumberInput');

var _PhoneNumberInput2 = _interopRequireDefault(_PhoneNumberInput);

var _communicationMethodTypes = require('ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes');

var _communicationMethodTypes2 = _interopRequireDefault(_communicationMethodTypes);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _getSalesPhoneNumber2 = require('ui-addon-upgrades/_core/common/adapters/getSalesPhoneNumber');

var _getSalesPhoneNumber3 = _interopRequireDefault(_getSalesPhoneNumber2);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _submitPql = require('ui-addon-upgrades/_core/pql/submitPql');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PHONE_NUMBERS_URL = 'https://www.hubspot.com/company/contact';

var CommunicationSelectedMethodCall = function (_React$Component) {
  _inherits(CommunicationSelectedMethodCall, _React$Component);

  function CommunicationSelectedMethodCall(props) {
    _classCallCheck(this, CommunicationSelectedMethodCall);

    var _this = _possibleConstructorReturn(this, (CommunicationSelectedMethodCall.__proto__ || Object.getPrototypeOf(CommunicationSelectedMethodCall)).call(this, props));

    _this.state = {
      phoneNumber: '',
      phoneNumberSubmitted: false
    };

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    return _this;
  }

  _createClass(CommunicationSelectedMethodCall, [{
    key: 'handleSubmit',
    value: function handleSubmit() {
      var phoneNumber = this.state.phoneNumber;
      var upgradeData = this.props.upgradeData;

      // Don't send PQL if user doesn't provide number

      if (!phoneNumber) {
        return;
      }

      (0, _submitPql.submitPql)(upgradeData, {
        phoneNumberSubmitted: true,
        phoneNumber: phoneNumber
      });

      this.setState({
        isPhoneNumberSubmitted: true
      });

      tracker.track('communicationMethodsInteraction', _extends({
        action: 'submitted phone number'
      }, upgradeData));
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var setSelectedCommunicationMethod = this.props.setSelectedCommunicationMethod;


      setSelectedCommunicationMethod(_communicationMethodTypes2.default.INITIAL);
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(_ref) {
      var phoneNumber = _ref.phoneNumber;

      this.setState({ phoneNumber: phoneNumber });
    }
  }, {
    key: 'renderSuccessCopy',
    value: function renderSuccessCopy() {
      var onDark = this.props.onDark;

      var linkUse = onDark ? 'on-dark' : 'dark';

      var _getSalesPhoneNumber = (0, _getSalesPhoneNumber3.default)(_I18n2.default.lang, _I18n2.default.locale),
          phoneNumber = _getSalesPhoneNumber.phoneNumber,
          countryCode = _getSalesPhoneNumber.countryCode;

      return _react2.default.createElement(
        'div',
        { className: 'communication-call-submit-success' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.callSuccess' })
        ),
        _react2.default.createElement(
          'h6',
          { className: 'is--heading-6 uppercase' },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.localization.or' })
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.localization.callNow' })
        ),
        _react2.default.createElement(
          'h4',
          { className: 'is--heading-4 m-bottom-0' },
          phoneNumber
        ),
        _react2.default.createElement(
          _Small2.default,
          null,
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'SharedI18nStrings.countryCodes.' + countryCode
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'm-top-8' },
          _react2.default.createElement(
            _UILink2.default,
            { use: linkUse, href: PHONE_NUMBERS_URL, external: true },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.localization.viewAllButton' })
          )
        )
      );
    }
  }, {
    key: 'renderPhoneNumberInput',
    value: function renderPhoneNumberInput() {
      var onDark = this.props.onDark;

      var buttonUse = onDark ? 'primary-white' : 'primary';
      var linkUse = onDark ? 'link-on-dark' : 'link';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_PhoneNumberInput2.default, {
          className: 'm-bottom-6',
          style: { width: 'auto' },
          value: this.state.phoneNumber,
          onChange: this.handleInputChange
        }),
        _react2.default.createElement(
          _UIButton2.default,
          {
            className: 'communication-call-submit-button center-block m-bottom-4',
            onClick: this.handleSubmit,
            use: buttonUse
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.callButton' })
        ),
        _react2.default.createElement(
          _UIButton2.default,
          {
            className: 'communication-call-back-button center-block',
            use: linkUse,
            onClick: this.handleClick
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.backButton' })
        )
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var isPhoneNumberSubmitted = this.state.isPhoneNumberSubmitted;


      if (isPhoneNumberSubmitted) {
        return this.renderSuccessCopy();
      }

      return this.renderPhoneNumberInput();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'selected-method-call text-center' },
        _react2.default.createElement(
          'h2',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.callTitle' })
        ),
        this.renderContent()
      );
    }
  }]);

  return CommunicationSelectedMethodCall;
}(_react2.default.Component);

CommunicationSelectedMethodCall.defaultProps = {
  setSelectedCommunicationMethod: _emptyFunction2.default
};

CommunicationSelectedMethodCall.propTypes = _extends({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  setSelectedCommunicationMethod: _react.PropTypes.func.isRequired
});

exports.default = CommunicationSelectedMethodCall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/CommunicationSelectedMethodCall.js
// module id = 554
// module chunks = 3 4 5